import { Text, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton, { ActionLink } from 'components/action-button';

export const LoadingText = Text.withConfig({
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
  fontFamily: 'body',
  paddingY: '$2',
});

export const StyledActionButton = makeUclComponent(ActionButton).withConfig({
  _text: { fontFamily: 'alternative' },
});

export const StyledActionLink = makeUclComponent(ActionLink).withConfig({
  _text: { fontFamily: 'alternative' },
});
